module.exports = __webpack_public_path__ + "img/V-63-ST-1500-N.7ab042f6.png";